/**
 * Opção da PROPOSTA (mode=orcamento): o fornecedor escolhe mostrar ao cliente só os itens que selecionou
 * (mais os adicionais com custo), em vez de todo o cardápio com os itens não escolhidos apagados.
 * Vale para a sessão de montagem da proposta; vai para o evento dentro de menu[].showOnlySelected.
 */
export const QUOTE_ONLY_SELECTED_KEY = 'ameup_quote_only_selected';
/** Disparado quando o carregador do link termina de gravar a proposta (snapshot ameup_shared_quoted_items) na sessão. */
export const SHARED_QUOTE_LOADED_EVENT = 'ameup-shared-quote-loaded';

const readSessionItems = (key: string): any[] => {
  try {
    const raw = sessionStorage.getItem(key);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

/**
 * Itens da proposta na sessão: o carrinho e o snapshot da proposta compartilhada. O CLIENTE que abre o link fica com o
 * carrinho vazio de propósito; a proposta do fornecedor só existe no snapshot.
 */
export const readProposalItems = (): any[] => [
  ...readSessionItems('supplier_cart_items'),
  ...readSessionItems('ameup_shared_quoted_items'),
];

export const getQuoteOnlySelected = (): boolean => {
  try {
    return sessionStorage.getItem(QUOTE_ONLY_SELECTED_KEY) === 'true';
  } catch {
    return false;
  }
};

export const setQuoteOnlySelected = (value: boolean): void => {
  try {
    if (value) sessionStorage.setItem(QUOTE_ONLY_SELECTED_KEY, 'true');
    else sessionStorage.removeItem(QUOTE_ONLY_SELECTED_KEY);
  } catch {
    /* sem sessionStorage: a opção não persiste */
  }
};

/** O fornecedor só decide isso quando algum item do carrinho tem escolhas por categoria (cardápio fixo com "escolha N de M"). */
export const cartHasChoiceCategories = (items: Array<{ categorySelections?: Record<string, string[]> }>): boolean =>
  items.some((item) => !!item.categorySelections && Object.values(item.categorySelections).some((list) => list.length > 0));

/**
 * Cliente abrindo a proposta: vê só o que o fornecedor escolheu? Nunca no modo orçamento (o fornecedor precisa ver tudo
 * para continuar editando).
 */
export const shouldShowOnlySelected = (
  items: Array<{ productId: string; fromSharedQuote?: boolean; showOnlySelected?: boolean }>,
  productId: string | null | undefined,
  inQuoteMode: boolean,
): boolean => {
  if (inQuoteMode || !productId) return false;
  return items.some((item) => item.fromSharedQuote === true && item.showOnlySelected === true && item.productId === productId);
};
